import React from 'react';
import { ArrowPathIcon, ClipboardDocumentCheckIcon, CalendarDaysIcon, UsersIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import { Container } from '../common/Container';

const benefits = [
  {
    Icon: ArrowPathIcon,
    title: 'Start with a complete file',
    description: 'Authorization, property, and county data in one place.',
  },
  {
    Icon: ClipboardDocumentCheckIcon,
    title: 'Keep every case moving',
    description: 'Deadlines, documents, decisions, and ownership stay with the appeal.',
  },
  {
    Icon: CalendarDaysIcon,
    title: 'Close the loop faster',
    description: 'Record the result, update the client, and move the file to invoice.',
  },
];

export const Features: React.FC = () => {
  return (
    <section className="bg-white py-24" aria-labelledby="benefits-heading">
      <Container>
        <div className="mx-auto max-w-3xl text-center">
          <h2 id="benefits-heading" className="text-4xl font-bold tracking-tight text-brand-blue sm:text-5xl">
            One workflow for the entire appeal.
          </h2>
        </div>

        <div className="mt-14 grid border-y border-gray-200 md:grid-cols-3">
          {benefits.map((benefit, index) => (
            <article key={benefit.title} className={`py-9 md:px-8 ${index < 2 ? 'border-b border-gray-200 md:border-b-0 md:border-r' : ''} ${index === 0 ? 'md:pl-0' : ''}`}>
              <benefit.Icon className="h-9 w-9 text-brand-red" />
              <h3 className="mt-6 text-2xl font-bold text-brand-blue">{benefit.title}</h3>
              <p className="mt-3 text-lg text-brand-white-700">{benefit.description}</p>
            </article>
          ))}
        </div>

        <div className="mt-12 grid gap-7 rounded-2xl bg-brand-blue-50 p-8 md:grid-cols-[auto_1fr_1fr] md:items-center lg:p-10">
          <div className="flex h-14 w-14 items-center justify-center rounded-xl bg-brand-blue text-white">
            <UsersIcon className="h-7 w-7" />
          </div>
          <div>
            <h3 className="text-2xl font-bold text-brand-blue">Keep clients informed.</h3>
            <p className="mt-2 text-brand-white-700">Share live status, deadlines, and selected documents.</p>
          </div>
          <div className="flex items-center gap-3 rounded-xl bg-white px-5 py-4 text-sm text-brand-white-700">
            <LockClosedIcon className="h-5 w-5 flex-shrink-0 text-brand-red" />
            You control what clients see. Internal work stays private.
          </div>
        </div>
      </Container>
    </section>
  );
};
